import { Feature } from 'config/features';

import { ReducerAction } from 'types/reducer';

export enum FeatureAction {
    InitAsync = 'initAsync',
    ActivateFeature = 'activateFeature',
    DeactivateFeature = 'deactivateFeature',
    UpdateFeatureState = 'updateFeatureState',
}

interface UpdateFeature {
    name: Feature;
    activate: boolean;
}

export type FeatureReducerAction =
    | ReducerAction<FeatureAction.InitAsync, Feature[]>
    | ReducerAction<FeatureAction.ActivateFeature, Feature>
    | ReducerAction<FeatureAction.DeactivateFeature, Feature>
    | ReducerAction<FeatureAction.UpdateFeatureState, UpdateFeature>;
